<template>
  <div class="mt-12">
    <div class="py-2 text-center font-bold border-gray-300 border-b">時刻設定</div>
    <div class="px-6 py-2">
      <div @click="$emit('setSearchType', 'departure')" class="float-left py-1 font-bold border w-1/4 text-center bg-white rounded-l-md" :class="searchType === 'departure' ? 'border-link text-link' : 'border-gray-300'">出発</div>
      <div @click="$emit('setSearchType', 'arrival')" class="float-left py-1 font-bold border w-1/4 text-center bg-white" :class="searchType === 'arrival' ? 'border-link text-link' : 'border-gray-300'">到着</div>
      <div @click="$emit('setSearchType', 'firstTrain')" class="float-left py-1 font-bold border w-1/4 text-center bg-white" :class="searchType === 'firstTrain' ? 'border-link text-link' : 'border-gray-300'">始発</div>
      <div @click="$emit('setSearchType', 'lastTrain')" class="float-left py-1 font-bold border w-1/4 text-center bg-white rounded-r-md" :class="searchType === 'lastTrain' ? 'border-link text-link' : 'border-gray-300'">終電</div>
    </div>
    <div v-if="searchType === 'departure' || searchType === 'arrival'" class="px-6 text-center">
      <input class="mx-1 px-4 py-1 mt-2 border border-gray-300 rounded-md" type="date" @change="$emit('setDate', $event.target.value)" :value="getDate()">
      <input class="mx-1 px-4 py-1 mt-2 border border-gray-300 rounded-md" type="time" @change="$emit('setTime', $event.target.value)" :value="getTime()">
    </div>
    <div v-else class="px-6 text-center">
      <input class="px-4 py-1 mt-2 border border-gray-300 rounded-md" type="date" @change="$emit('setDate', $event.target.value)" :value="getDate()">
    </div>
    <div class="clear-both text-center py-2">
      <a @click="$emit('setNow')" class="font-bold">現在時刻にする</a>
    </div>
    <div class="px-12">
      <a class="button-primary py-2 block" @click="$emit('closeDatetime')">
        設定する
      </a>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo');

export default {
  props: {
    date: {
      type: moment,
      required: true
    },
    time: {
      type: moment,
      required: true
    },
    searchType: {
      type: String,
      required: true
    }
  },
  methods: {
    getDate: function () {
      return this.date.format('YYYY-MM-DD')
    },
    getTime: function () {
      return this.time.format('HH:mm')
    }
  }
}
</script>